import PerfectScrollbar from 'perfect-scrollbar';

export default class Main {

  constructor() {
    // DOM is already ready by the time this runs — instantiated inside $(function() {...}) in the entry file
    this.initSafariCheck();
    // this.initDatetimePickers();
    this.initSliders();
    this.initSearchBar();
    this.initMegaMenu();
    this.initFakePlaceholder();
    this.initFontSwitcher();
    this.initMobileMenu();
    this.initMobileFooter();
    this.initMobileTab();
    this.initPerfectScrollbar();
    this.initDropdownScrollable();
    this.initContentPageTabs();
    this.initPopovers();
    this.initMobileSubMenu();
    this.initMobileNavTabs();
    this.initBannersAndAlerts();

    // These still need full page load, not just DOM-ready
    window.addEventListener('load', () => {
      this.initFormValidation();
    }, false);

    $(window).on('load', () => {
      this.initAdaFixes();
    });
  }

  // ---------------------------------
  // Safari detection
  // ---------------------------------
  initSafariCheck() {
    const isSafari = !!navigator.userAgent.match(/safari/i)
      && !navigator.userAgent.match(/chrome/i)
      && typeof document.body.style.webkitFilter !== 'undefined'
      && !window.chrome;

    if (isSafari) {
      $('body').addClass('safari');
    }
  }

  // ---------------------------------
  // Datepicker / Timepicker
  // ---------------------------------
  initDatetimePickers() {
    const dateEl = document.querySelector('#date');
    const timeEl = document.querySelector('#time');

    if (dateEl) {
      flatpickr(dateEl, {
        dateFormat: 'm/d/Y',
      });
    }

    if (timeEl) {
      flatpickr(timeEl, {
        noCalendar: true,
        enableTime: true,
        time_24hr: true,
        dateFormat: 'H:i',
      });
    }
  }

  // ---------------------------------
  // Sliders (slick)
  // ---------------------------------
  initSliders() {
    $('.section--slider .box-wrapper--slider').each(function () {
      $(this).slick({
        arrow: true,
        autoplay: true,
        dots: false,
        speed: 1500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              arrow: false,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              arrow: false,
              dots: true,
              centerMode: true,
              centerPadding: '10%',
            },
          },
          {
            breakpoint: 360,
            settings: {
              slidesToShow: 1,
              arrow: false,
              dots: true,
              centerMode: true,
              centerPadding: '0',
            },
          },
        ],
      });
    });

    $('.section--box .box-wrapper').slick({
      infinite: false,
      speed: 1000,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      responsive: [
        {
          breakpoint: 9999,
          settings: 'unslick',
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            arrow: false,
            dots: true,
            centerMode: true,
            centerPadding: '10%',
          },
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 1,
            arrow: false,
            dots: true,
            centerMode: true,
            centerPadding: '0',
          },
        },
      ],
    });

    $('.product-details-slider-thumb').slick({
      dots: false,
      arrows: true,
      vertical: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      verticalSwiping: true,
      asNavFor: '.product-details-slider-photo',
    });

    $('.product-details-slider-photo').slick({
      dots: false,
      arrows: false,
      asNavFor: '.product-details-slider-thumb',
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }

  // ---------------------------------
  // Search bar
  // ---------------------------------
  initSearchBar() {
    $('.header').on('click', '.header--search', () => {
      $('.header--search_open').toggleClass('open');
    });

    if ($(window).width() < 767) {
      $('.header').on('click', '.header--search', () => {
        $('.overlay').toggleClass('open');
      });
    }

    $('.header .header--search_open').on('click', 'a.close-search', (e) => {
      $('.header--search_open').removeClass('open');
      e.preventDefault();
    });

    $(document).mouseup((e) => {
      const container = $('.header--search');
      const container2 = $('.header--search_open');

      if (
        !container.is(e.target) && container.has(e.target).length === 0
        && !container2.is(e.target) && container2.has(e.target).length === 0
      ) {
        $('.header--search_open').removeClass('open');
      }
    });
  }

  // ---------------------------------
  // Mega menu
  // ---------------------------------
  initMegaMenu() {
    const jsShowSubmenu = function () {
      $(this).addClass('open');
    };

    const jsHideSubmenu = function () {
      $(this).removeClass('open');
    };

    if ($('.header .header--menu')) {
      $('.header .header--menu').hoverIntent({
        over: jsShowSubmenu,
        out: jsHideSubmenu,
        timeout: 200,
        sensitivity: 6,
        interval: 100,
        selector: 'li.menu-item-has-children',
      });
    }
  }

  // ---------------------------------
  // Fake placeholder
  // ---------------------------------
  initFakePlaceholder() {
    const $inputs = $('.hero .tab-content .form-group input');

    $inputs.on('focusin', function () {
      $(this).parent().find('label').hide();
    });

    $inputs.on('focusout', function () {
      $(this).parent().find('label').show();
    });

    $inputs.on('keyup change', function () {
      if ($(this).val() != '') {
        $(this).parent().find('label').hide();
      } else {
        $(this).parent().find('label').show();
      }
    });

    $inputs.each(function () {
      if ($(this).val() != '') {
        $(this).parent().find('label').hide();
      } else {
        $(this).parent().find('label').show();
      }
    });

    $('.hero .tab-content .form-group').on('click', 'label', function () {
      $(this).parent().find('input').focus();
    });
  }

  // ---------------------------------
  // Font size switcher
  // ---------------------------------
  initFontSwitcher() {
    $('.change-font').on('click', 'a', function (e) {
      e.preventDefault();
      $('.change-font a.size').removeClass('active');
      $(this).addClass('active');

      if ($(this).hasClass('font-size-1')) {
        $('body').removeClass('text-size2 text-size3');
      } else if ($(this).hasClass('font-size-2')) {
        $('body').removeClass('text-size3').addClass('text-size2');
      } else if ($(this).hasClass('font-size-3')) {
        $('body').removeClass('text-size2').addClass('text-size3');
      }
    });
  }

  // ---------------------------------
  // Mobile menu
  // ---------------------------------
  initMobileMenu() {
    $(document).on('click', '.menu-hamburger', (e) => {
      if ($('.overlay').hasClass('open')) {
        $('.overlay').removeClass('open');
      } else {
        $('.overlay').addClass('open');
      }
      e.preventDefault();
    });

    $(document).mouseup((e) => {
      const container = $('.box-wrap');

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.overlay').removeClass('open');
      }
    });
  }

  // ---------------------------------
  // Mobile footer
  // ---------------------------------
  initMobileFooter() {
    $('.footer .footer-col').on('click', 'h3', function (e) {
      const screen = $(window);
      if (screen.width() < 992) {
        $(this).toggleClass('active');
        $(this).parent().find('ul').toggleClass('open');
        e.preventDefault();
      }
    });
  }

  // ---------------------------------
  // Mobile tab
  // ---------------------------------
  initMobileTab() {
    $('.mobile-tab').on('click', 'h3', function (e) {
      $(this).toggleClass('active');
      $(this).parent().find('ul').toggleClass('open');
      e.preventDefault();
    });
  }

  // ---------------------------------
  // Perfect scrollbar
  // ---------------------------------
  initPerfectScrollbar() {
    const el = document.querySelector('.overlay .overlay-container');
    if (el) {
      new PerfectScrollbar(el);
    }
  }

  // ---------------------------------
  // Dropdown with scroll arrow
  // ---------------------------------
  initDropdownScrollable() {
    // prevent hiding dropdown after click inside dropdown
    $('.dropdown--scrollable .dropdown-menu, .hero .tab-content .dropdown .dropdown-menu').click((e) => {
      e.stopPropagation();
    });

    $('.dropdown--scrollable .dropdown-menu__content').each(function () {
      $(this).slick({
        infinite: false,
        vertical: true,
        slidesToShow: $(this).data('items'),
        slidesToScroll: $(this).data('items-scroll'),
        dots: false,
        prevArrow: $(this).parent().find('a.up'),
        nextArrow: $(this).parent().find('a.down'),
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            },
          },
        ],
      });

      const carousel = $(this);

      $(this).parents('.dropdown--scrollable').on('click', 'button', () => {
        carousel.slick('refresh');
      });
    });
  }

  // ---------------------------------
  // Content page tabs
  // ---------------------------------
  initContentPageTabs() {
    $('.content-page--text a[data-toggle="tab"]').on('show.bs.tab', function (e) {
      $('.content-page--text .nav-tabs li').removeClass('active');
      $(this).parent().addClass('active');
    });

    $('.content-page .nav-tabs').each(function () {
      $(this).addClass('d-block d-lg-flex ps-0 ps-lg-2');
    });
  }

  // ---------------------------------
  // Bootstrap popovers
  // ---------------------------------
  initPopovers() {
    $('[data-toggle="popover"]').popover();
  }

  // ---------------------------------
  // Mobile sub menu (select dropdown)
  // ---------------------------------
  initMobileSubMenu() {
    $('#subMenu').each(function () {
      const list = $(this);
      const select = $(document.createElement('select'))
        .addClass('subMenuSelect form-control mb-5 d-block d-lg-none')
        .attr('aria-label', 'Sidebar page navigation')
        .insertAfter($('.breadcrumb'));

      $(this).addClass('d-none d-lg-block');
      select.append($('<option></option>').val('').html('Navigate'));

      $('#subMenu li a').each(function () {
        $(document.createElement('option'))
          .appendTo(select)
          .val(this.href)
          .html($(this).html())
          .click(function () {
            window.location.href = $(this).val();
          });
      });
    });

    $('.subMenuSelect').on('change', function () {
      const url = $(this).val();
      if (url) {
        window.location = url;
      }
      return false;
    });
  }

  // ---------------------------------
  // Mobile nav tabs
  // ---------------------------------
  initMobileNavTabs() {
    $('.content-page .nav-tabs').each(function () {
      $(this).addClass('d-block d-lg-flex ps-0 ps-lg-2');
    });
  }

  // ---------------------------------
  // Bootstrap custom form validation
  // ---------------------------------
  initFormValidation() {
    const forms = document.getElementsByClassName('needs-validation');

    Array.prototype.filter.call(forms, (form) => {
      form.addEventListener('submit', (event) => {
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add('was-validated');
      }, false);
    });
  }

  // ---------------------------------
  // Banners / Alerts
  // ---------------------------------
  initBannersAndAlerts() {
    if (!localStorage.bannerClosed) {
      $('.privacy-banner').css('display', 'inherit');
    } else {
      $('.privacy-banner').css('display', 'none');
    }

    $('.privacy-banner button').click(() => {
      $('.privacy-banner').css('display', 'none');
      localStorage.bannerClosed = 'true';
    });

    $('.banner-accept').click(() => {
      $('.privacy-banner').css('display', 'none');
      localStorage.bannerClosed = 'true';
    });

    if (navigator.userAgent.match(/Opera|OPR\//)) {
      $('.privacy-banner').css('display', 'inherit');
    }

    const alert = $('.alert').attr('id');

    if (alert) {
      if (!localStorage[alert]) {
        $('.alert').css('display', 'inherit');
      } else {
        $('.alert').css('display', 'none');
      }

      $('.alert__hide').click(() => {
        $('.alert').css('display', 'none');
        localStorage[alert] = 'true';
      });

      if (navigator.userAgent.match(/Opera|OPR\//)) {
        $('.alert').css('display', 'inherit');
      }
    }
  }

  // ---------------------------------
  // ADA fixes
  // ---------------------------------
  initAdaFixes() {
    $('u').each(function () {
      $(this).replaceWith(`<span style='text-decoration: underline;'>${$(this).html()}</span>`);
    });

    $('b').each(function () {
      $(this).replaceWith(`<span class='font-weight-bold'>${$(this).html()}</span>`);
    });

    $('em').each(function () {
      $(this).replaceWith(`<span class='font-italic'>${$(this).html()}</span>`);
    });

    $('strong').each(function () {
      $(this).replaceWith(`<span class='font-weight-bold'>${$(this).html()}</span>`);
    });
  }
}